export default {
  getToken: (axios, url) => axios.get(url),
}
